import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { DataService } from '@shared/lib/services/data.service';
import { LocaleService } from '@shared/lib/services/locale.service';
import { Market, UsanaMarketService } from '@usana/ux/markets';

@Component({
  selector: 'u-dm',
  template:
    '<router-outlet></router-outlet>' +
    '<u-locale-confirmation *ngIf="showMarketConfirmation" ' +
    '[locale]="resolvedLocale" ' +
    '(chosenOne)="youWereTheChosenLocale($event)"></u-locale-confirmation>',
  standalone: false,
})
export class DetermineMarketComponent implements OnInit {
  showMarketConfirmation: boolean;
  resolvedLocale: string;

  constructor(
    private route: ActivatedRoute,
    private usanaMarketService: UsanaMarketService,
    private localeService: LocaleService,
    private readonly dataService: DataService,
  ) {}

  ngOnInit(): void {
    this.dataService.init(); // this determines if we are prerender
    this.route.data.subscribe((data) => {
      this.resolvedLocale = (data['market'] as Market).currentMarketId;
      // check if they have confirmed, and we are fancy mode (not prerender)
      this.showMarketConfirmation = this.dataService.isFancyMode() && !this.localeService.hasConfirmedLocaleCookie();
    });
  }

  youWereTheChosenLocale(chosenLocale: string): void {
    // conform
    this.showMarketConfirmation = false;
    this.localeService.bumpConfirmedLocaleCookie();

    if (chosenLocale !== this.resolvedLocale) {
      // bring balance by switching locales
      this.usanaMarketService.setMarketId(chosenLocale);
    }
  }
}
